import { useState } from "react";
import {  Typography, Button, Collapse,Box, styled } from "@mui/material";

import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import founder from '../assets/founder.jpg';
import { useSectionData } from "../hooks/useFirebaseData";
import DescriptionSkeleton from "./ui/DescriptionSkeleton";

export default function Founder() {
    const {
      data: founderData,
      loading,
      error,
    } = useSectionData("founder", "founder");
    
  const [expanded, setExpanded] = useState(false);

  const RoundedImage = styled('img')({
    width: '205px',
    height: '250px',
    borderRadius: '5%',
    objectFit: 'cover', 
  });

  if (loading) {
    return (
     <DescriptionSkeleton/>
    );
  }

  if (error) {
    return (
      <Box sx={{ padding: 5, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Typography variant="h6" sx={{ color: 'error.main' }}>
          データの読み込み中にエラーが発生しました
        </Typography>
      </Box>
    );
  }

  if (!founderData) {
    return null;
  }

  const sectionTitles = founderData.sectionTitles 
  return (
    <Box sx={{ padding: 5, flexDirection: 'column', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Typography variant="h6" sx={{ my: 3, color: '#E87F11', textAlign: 'left', fontSize: { xs: '1.75rem', md: '2rem' } }}>
        <strong>{founderData.title}</strong>
      </Typography>

      <Box>
        {founderData.image ? (
          <RoundedImage src={founderData.image} alt="Founder" />
        ) : (
          <RoundedImage src={founder} alt="Founder" />
        )}
      </Box>

      <Typography variant="body1" sx={{ mt: 3, color: '#E87F11', maxWidth: '2000px', mx: '3', textAlign: 'left', fontSize: { xs: '1rem', md: '1.25rem' } }}>
        <strong>{founderData.name}</strong>
        <br />
        {founderData.role}
        <br />
        
        <br /><strong>{sectionTitles.profile}</strong>
        <br />
        {founderData.profile}
        <Typography variant="body1" sx={{ mt: 3, color: '#E87F11', fontSize: { xs: '1rem', md: '1.25rem' } }}>
          <strong>{sectionTitles.achievements}</strong>
        </Typography>
       
        {/* Map through achievements array */}
        {founderData.achievements && founderData.achievements.map((achievement, index) => (
          <div key={index}>
            • {achievement}
            <br />
          </div>
        ))}
        
        <br />
        {sectionTitles.closingStatement}
      </Typography>

      <Collapse in={expanded} timeout="auto" unmountOnExit sx={{maxWidth: '2000px', mx: '3'}}>
        <br /><Typography variant="body1" sx={{ mt: 3, color: '#E87F11', fontSize: { xs: '1rem', md: '1.25rem' } }}>
          <strong>{sectionTitles.thoughts}</strong>
        </Typography>
        <Typography variant="body1" sx={{ mt: 1, color: '#E87F11', fontSize: { xs: '1rem', md: '1.25rem' } }}>
          {founderData.thoughts}
        </Typography>

        <Typography variant="body1" sx={{ mt: 3, color: '#E87F11', fontSize: { xs: '1rem', md: '1.25rem' } }}>
          <strong>{sectionTitles.socialAndFitness}</strong>
        </Typography>
        <Typography variant="body1" sx={{ mt: 1, color: '#E87F11', fontSize: { xs: '1rem', md: '1.25rem' } }}>
          {founderData.socialContribution}
          <br />
          <br />
          {founderData.gymPurpose}
        </Typography>

        <br /><Typography variant="body1" sx={{ mt: 3, color: '#E87F11', fontSize: { xs: '1rem', md: '1.25rem' } }}>
          <strong>{sectionTitles.message}</strong>
        </Typography>
        <Typography variant="body1" sx={{ mt: 1, color: '#E87F11', fontSize: { xs: '1rem', md: '1.25rem' } }}>
          {founderData.message}
        </Typography>
      </Collapse>

      <Button
        variant="contained"
        endIcon={expanded ? <ExpandLessIcon /> : <ExpandLessIcon />}
        onClick={() => setExpanded(!expanded)}
        sx={{ mt: 2, bgcolor: '#E87F11', fontSize: { xs: '1rem', md: '1.25rem' } }}
      >
        {expanded ? "閉じる" : "もっと見る"}
      </Button>
    </Box>
  );
}